import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { DataTable } from '@uhg-abyss/web/ui/DataTable';
import { useDataTable } from '@uhg-abyss/web/hooks/useDataTable';
import Markdown from 'markdown-to-jsx';

const Wrapper = styled.div({
  padding: '16px 32px 32px 0px',
});

const TableHead = styled('p', {
  color: 'rgb(0, 38, 119)',
  marginBottom: '0',
});

const StyledUL = styled('ul', {
  listStyleType: 'revert',
  marginBottom: '20px',
  color: 'rgb(0, 0, 0)',
  paddingLeft: '40px',
  fontSize: '14px',
});

const StyledLI = styled('li', {
  fontWeight: 'normal',
  fontSize: '14px',
});

const Note = styled('p', {
  marginBottom: 0,
  fontSize: '14px',
});

const DescWithNote = styled('div', {});

export const ErrorCodesV3 = ({ currentApi }) => {
  const [responses, setResponses] = useState([]);

  const columns = React.useMemo(() => {
    return [
      {
        Header: <TableHead>Code</TableHead>,
        accessor: 'code',
        disableResizing: true,
      },
      {
        Header: <TableHead>Description</TableHead>,
        accessor: 'description',
      },
    ];
  }, []);

  const dataTableProps = useDataTable({
    showPagination: false,
    initialData: responses,
    initialColumns: columns,
  });

  const updateTable = (newData) => {
    dataTableProps.setData(newData, true);
  };

  const createHtmlData = (string) => {
    const escapedString = string.replace(
      /\b(\w+)_(\w+)_(\w+)(?:_(\w+))?(?:_(\w+))?\b/g,
      (m) => {
        // First escape backslashes, then underscores
        return m.replace(/\\/g, '\\\\').replace(/_/g, '\\_');
      }
    );
    return (
      <Markdown
        options={{
          overrides: {
            ul: StyledUL,
            li: StyledLI,
            p: DescWithNote,
            note: Note,
          },
        }}
      >
        {escapedString}
      </Markdown>
    );
  };

  useEffect(() => {
    if (currentApi.responses.length) {
      const data = [...currentApi.responses].map((el) => {
        return { code: el.status, description: createHtmlData(el.description) };
      });
      updateTable(data);
      setResponses(data);
    }
  }, [currentApi]);

  return (
    <Wrapper>
      <DataTable tableState={dataTableProps} />
    </Wrapper>
  );
};

ErrorCodesV3.propTypes = {
  currentApi: PropTypes.shape({
    description: PropTypes.string,
    responses: PropTypes.arrayOf(
      PropTypes.shape({
        status: PropTypes.string,
        description: PropTypes.string,
      })
    ),
  }),
};

ErrorCodesV3.defaultProps = {
  currentApi: { description: '', responses: [] },
};
